// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../../../assets/images/food-preferences/toggler/feature-congrats.gif", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toggler {
  position: relative;
}
.toggler .header-toggler {
  position: absolute;
  right: 5%;
  top: 14%;
}
.toggler .header-toggler .toggler-badge {
  background: #333333;
  border-radius: 10px;
}
.toggler .header-toggler .toggler-badge:hover {
  height: 200px;
}
.toggler .header-toggler .toggler-badge-two {
  height: 200px;
}
.toggler .header-toggler .upcoming-bookings {
  display: block;
  background: #3c3c3c;
  position: absolute;
  right: 50px;
  width: 200px;
  height: 134px;
  margin-left: -12.5rem;
  border-radius: 10px 0px 10px 10px;
}
.toggler .header-toggler .upcoming-bookings .upcoming-bookings-inner {
  display: flex;
  justify-content: space-between;
}
.toggler .header-toggler .upcoming-bookings .bookings-heading {
  font-size: 10px;
  text-align: left;
  margin-left: 0rem;
  padding-left: 2em;
}
.toggler .header-toggler .upcoming-bookings .bookings-heading-data {
  font-size: 10px;
  list-style: none;
  text-align: left;
  margin-right: 1rem;
  padding-left: 0px;
  margin-left: 0px;
}
.toggler .header-toggler .upcoming-bookings .confirm-booking-btn {
  height: 23px;
  background: #299541;
  border-radius: 4px;
  border: none;
  color: white;
  cursor: pointer;
  margin-top: 10px;
}
.toggler .header-toggler .hover-bookings {
  writing-mode: vertical-rl !important;
  margin-top: 0.5rem;
  white-space: nowrap;
  font-size: 12px;
  align-items: center;
  margin-left: 8.5px;
  z-index: 5;
}
.toggler .header-toggler .dispay-none {
  display: none !important;
}
.toggler .header-toggler .badge-div {
  background-color: green;
  width: 40px;
  height: 40;
}

.header-toggler-two {
  position: relative;
  animation-name: slideNotification;
  animation-duration: 0.2s;
  animation-timing-function: ease-out;
}
@keyframes slideNotification {
  to {
    right: 80px;
  }
  from {
    right: -200px;
  }
}

.arrow-img:hover {
  cursor: pointer;
}

.hover-bookings-display {
  display: block;
}

.confirmBooking {
  position: absolute;
  height: 489px;
  width: 806.64px;
  top: 25%;
  left: 30%;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  background: white;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 100%;
  z-index: 3;
  justify-content: center;
  align-items: center;
}
.confirmBooking h1 {
  color: #ff611d;
  line-height: 0%;
}
.confirmBooking p {
  color: black;
  line-height: 0%;
  font-weight: 700;
}
.confirmBooking .bgStar {
  position: absolute;
}`, "",{"version":3,"sources":["webpack://./src/features/food/common/header/components/toggler/toggler.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;AAAE;EACE,kBAAA;EACA,SAAA;EACA,QAAA;AAEJ;AADI;EAEE,mBAAA;EAGA,mBAAA;AAAN;AAGM;EACE,aAAA;AADR;AAII;EACE,aAAA;AAFN;AAKI;EACE,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,iCAAA;AAHN;AAKM;EACE,aAAA;EACA,8BAAA;AAHR;AAMM;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AAJR;AAOM;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;AALR;AAQM;EACE,YAAA;EAEA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AAPR;AAWI;EACE,oCAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;AATN;AAYI;EACE,wBAAA;AAVN;AAaI;EACE,uBAAA;EACA,WAAA;EACA,UAAA;AAXN;;AAeA;EACE,kBAAA;EACA,iCAAA;EAEA,wBAAA;EACA,mCAAA;AAbF;AAeE;EACE;IACE,WAAA;EAbJ;EAeE;IACE,aAAA;EAbJ;AACF;;AAgBA;EACE,eAAA;AAbF;;AAgBA;EACE,cAAA;AAbF;;AAgBA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,yBAAA;EACA,UAAA;EACA,uBAAA;EACA,mBAAA;AAbF;AAcE;EACE,cAAA;EAEA,eAAA;AAbJ;AAeE;EACE,YAAA;EAEA,eAAA;EACA,gBAAA;AAdJ;AAgBE;EACE,kBAAA;AAdJ","sourcesContent":[".toggler {\n  position: relative;\n  .header-toggler {\n    position: absolute;\n    right: 5%;\n    top: 14%;\n    .toggler-badge {\n      // position: absolute !important;\n      background: #333333;\n      // top: -33px !important;\n      // z-index: 4 !important;\n      border-radius: 10px;\n      // border-bottom-left-radius:0px ;\n      // border: 1px solid red;\n      &:hover {\n        height: 200px;\n      }\n    }\n    .toggler-badge-two {\n      height: 200px;\n    }\n\n    .upcoming-bookings {\n      display: block;\n      background: #3c3c3c;\n      position: absolute;\n      right: 50px;\n      width: 200px;\n      height: 134px;\n      margin-left: -12.5rem;\n      border-radius: 10px 0px 10px 10px;\n\n      .upcoming-bookings-inner {\n        display: flex;\n        justify-content: space-between;\n      }\n\n      .bookings-heading {\n        font-size: 10px;\n        text-align: left;\n        margin-left: 0rem;\n        padding-left: 2em;\n      }\n\n      .bookings-heading-data {\n        font-size: 10px;\n        list-style: none;\n        text-align: left;\n        margin-right: 1rem;\n        padding-left: 0px;\n        margin-left: 0px;\n      }\n\n      .confirm-booking-btn {\n        height: 23px;\n        // width: 83px;\n        background: #299541;\n        border-radius: 4px;\n        border: none;\n        color: white;\n        cursor: pointer;\n        margin-top: 10px;\n      }\n    }\n\n    .hover-bookings {\n      writing-mode: vertical-rl !important;\n      margin-top: 0.5rem;\n      white-space: nowrap;\n      font-size: 12px;\n      align-items: center;\n      margin-left: 8.5px;\n      z-index: 5;\n    }\n\n    .dispay-none {\n      display: none !important;\n    }\n\n    .badge-div {\n      background-color: green;\n      width: 40px;\n      height: 40;\n    }\n  }\n}\n.header-toggler-two {\n  position: relative;\n  animation-name: slideNotification;\n  // border-bottom-left-radius: 0px;\n  animation-duration: 0.2s;\n  animation-timing-function: ease-out;\n\n  @keyframes slideNotification {\n    to {\n      right: 80px;\n    }\n    from {\n      right: -200px;\n    }\n  }\n}\n.arrow-img:hover {\n  cursor: pointer;\n}\n\n.hover-bookings-display {\n  display: block;\n}\n\n.confirmBooking {\n  position: absolute;\n  height: 489px;\n  width: 806.64px;\n  top: 25%;\n  left: 30%;\n  display: flex;\n  flex-direction: column;\n  border-radius: 8px;\n  background: white;\n  background-image: url(\"../../../../../../assets/images/food-preferences/toggler/feature-congrats.gif\");\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: 100%;\n  z-index: 3;\n  justify-content: center;\n  align-items: center;\n  h1 {\n    color: #ff611d;\n    // text-align: center;\n    line-height: 0%;\n  }\n  p {\n    color: black;\n    // text-align: center;\n    line-height: 0%;\n    font-weight: 700;\n  }\n  .bgStar {\n    position: absolute;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
